module.exports = {"outlet":"Outlet"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/royalty.php
// module id = ZrYr
// module chunks = 50